import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export const NoLocationsScreen: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 8, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          No Locations Available
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 500, mx: 'auto' }}>
          Your account does not currently have access to any forecast locations.
          Please contact your organisation administrator to request access.
        </Typography>
      </Box>
    </Container>
  );
};
